<template>
    <div>

         <CustomModal v-if="isModalOpen" ref="customModal" :modalId="modalId" :isOpen="isModalOpen" :showFooter="true" @modalClosed="modalClosed" :isStyle="'max-width:100% !important;'">
            
            <template #header>
                <h5 class="modal-title">{{ ['create','transfer'].includes(action) ? `${$t('create')} ${resolvedDocumentTitle}` : `${$t('edit')} ${resolvedDocumentTitle}` }}</h5>
                <small v-if="isDraftAutosaveEnabled && draftAutosaveState !== 'idle'" class="ms-auto me-3 text-muted d-flex align-items-center">
                    <span v-if="draftAutosaveState === 'saving'" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    <AppIcon name="bi-cloud-check" v-else-if="draftAutosaveState === 'saved'" class="bi bi-cloud-check me-1 text-success" />
                    <AppIcon name="bi-cloud-slash" v-else-if="draftAutosaveState === 'error'" class="bi bi-cloud-slash me-1 text-danger" />
                    <AppIcon name="bi-cloud-arrow-up" v-else class="bi bi-cloud-arrow-up me-1" />
                    {{ draftAutosaveStatusLabel }}
                </small>
                <button type="button" class="btn-close" id="close-modal-btn" data-bs-dismiss="modal" aria-label="Close" @click="modalClosed"></button>
            </template>

            <template #body>
                <div style="text-align:left">
                        <div class="row">
                            <div class="col-sm-2" v-if="helper.checkModuleIsEnabled('orders') && helper.checkAccess('view_orders') != -1">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('order')}}</label>
                                     <auto-complete 
                                        entity="orders"
                                        emitEvent="emitAutoCompleteOrder"
                                        :defaultValue="localData?.order?.reference" 
                                        @emitAutoCompleteOrder="emitAutoCompleteOrder">
                                    </auto-complete>
                                </div>
                            </div>

                            <div class="col-6 col-sm-2">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('reference')}}</label>
                                    <input v-model="localData.reference" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference">
                                </div>
                            </div>
                            <div class="col-6 col-sm-2">
                                <div class="mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('date')}}</label>
                                <input v-model="localData.date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="Date">
                            </div>
                            </div>
                            <div class="col-6 col-sm-2">
                                <div class="mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('due_date')}}</label>
                                <input v-model="localData.due_date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="Due Date">
                            </div>
                            </div>
                             <div class="col-6 col-sm-2" v-if="business?.metadata?.show_client_po_number">
                                <div class="mb-3">
                                    <label for="clientPoNumber" class="form-label">{{$t('client_po_number')}}</label>
                                    <input v-model="localData.client_po_number" type="text" class="form-control" id="clientPoNumber" :placeholder="$t('client_po_number')">
                                </div>
                            </div>
                            <div class="col-6 col-sm-2" v-if="business?.metadata?.show_client_dn_number">
                                <div class="mb-3">
                                    <label for="clientBlNumber" class="form-label">{{$t('client_dn_number')}}</label>
                                    <input v-model="localData.client_dn_number" type="text" class="form-control" id="clientBlNumber" :placeholder="$t('client_dn_number')">
                                </div>
                            </div>
                        </div>

                        <div v-if="recurringInvoiceFeatureEnabled" class="row align-items-end">
                            <div class="col-12 col-sm-4 col-lg-3">
                                <div class="form-check form-switch mb-3">
                                    <input
                                        id="recurringInvoiceToggle"
                                        v-model="localData.is_recurring"
                                        class="form-check-input"
                                        type="checkbox"
                                    >
                                    <label class="form-check-label" for="recurringInvoiceToggle">
                                        {{$t('recurring_invoice')}}
                                    </label>
                                    <div class="form-text">{{$t('recurring_invoice_description')}}</div>
                                </div>
                            </div>
                            <div v-if="localData.is_recurring" class="col-12 col-sm-4 col-lg-3">
                                <div class="mb-3">
                                    <label for="recurrenceInterval" class="form-label">{{$t('recurrence_interval')}}</label>
                                    <select id="recurrenceInterval" v-model="localData.recurrence_interval" class="form-select">
                                        <option value="day">{{$t('every_day')}}</option>
                                        <option value="week">{{$t('every_week')}}</option>
                                        <option value="month">{{$t('every_month')}}</option>
                                        <option value="quarter">{{$t('every_3_months')}}</option>
                                        <option value="half_year">{{$t('every_6_months')}}</option>
                                        <option value="year">{{$t('every_year')}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <hr>
                        <div class="mb-3">
                            <div class="">
                            <div v-for="(prd,i) in localData.products" :key="i" class="row mb-3">
                                <!-- Product selector: full width on mobile, compact on sm+ -->
                                <div class="col-12" :class="showProductUnit ? 'col-xl-4' : 'col-xl-5'">
                                    <div class="d-flex align-items-center" v-if="isProductModuleEnabled">
                                        <div class="form-check form-switch">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                :id="'paymentToggle'+i"
                                                v-model="localData.products[i].custom_product"
                                                :disabled="isProductFilled(localData.products[i])"
                                            >
                                        </div>
                                        <label :for="'paymentToggle'+i" class="form-label toggle-label me-3">{{localData.products[i].custom_product ? $t('custom_product') : $t('existing_product') }}</label>
                                    </div>
                                    <div v-else class="d-flex align-items-center">
                                        <label class="form-label toggle-label me-3">{{ $t('custom_product') }}</label>
                                    </div>

                                    <div class="d-flex">
                                        <div class="flex-grow-1">
                                            <!-- v-if="!localData.products[i].custom_product && createClientState === false"  -->
                                            <auto-complete  
                                                    :uid="i"
                                                    v-if="!localData.products[i].custom_product" 
                                                    @emitAutoComplete="emitAutoComplete" 
                                                    :defaultValue="localData.products[i].product_label" 
                                                    entity="inventories"
                                                    emitEvent="emitAutoComplete"
                                                    :dislaySuggestions="(action =='create' && !localData.products[i].product_id) ? true : false" 
                                                ></auto-complete>
                                                <div v-if="localData.products[i].variants && localData.products[i].variants.length" class="mt-2">
                                                    <select class="form-select form-select-sm" v-model="localData.products[i].variant_id" @change="onVariantChange(i)">
                                                        <option :value="null" disabled>Select Variant</option>
                                                        <option v-for="variant in localData.products[i].variants" :key="variant.id" :value="variant.id">
                                                            {{ variant.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <product-rich-text-editor
                                                    v-if="localData.products[i].custom_product"
                                                    v-model="localData.products[i].product_label"
                                                    :placeholder="$t('product_label')"
                                                ></product-rich-text-editor>
                                                <div v-if="localData.products[i].custom_product && canCreateCatalogProducts" class="form-check mt-2">
                                                    <input
                                                        v-model="localData.products[i].create_catalog_product"
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        :id="'invoiceCreateCatalogProduct' + i"
                                                    >
                                                    <label class="form-check-label" :for="'invoiceCreateCatalogProduct' + i">
                                                        {{ $t('also_add_to_products') }}
                                                    </label>
                                                </div>
                                                <div v-if="localData.products[i].product_id && (localData.products[i].maxQty <= 0)" class="text-danger small mt-1">
                                                    <AppIcon name="bi-exclamation-triangle-fill" class="bi bi-exclamation-triangle-fill me-1" /> {{ $t('product_out_of_stock_warning') }}
                                                </div>
                                        </div>
                                        <button type="button" class="btn line-item-delete-button ms-2 d-block d-sm-none align-self-start" :aria-label="$t('delete')" :title="$t('delete')" @click="removeRow(i)">
                                            <AppIcon name="bi-trash" class="bi bi-trash" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Price -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('price')}}</label>
                                    <input v-model="localData.products[i].price" @focus="handleInputFocus(localData.products[i], 'price')" @blur="handleInputBlur(localData.products[i], 'price', i)" @change="calculatePrices" class="form-control" placeholder="Price" type="number">                                
                                </div>
                                <!-- Qty -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('qty')}}</label> 
                                    <select v-if="!localData.products[i].custom_quantity_mode" class="form-select" :value="Number(localData.products[i].quantity)" @change="onQuantityChange(i, $event)">
                                        <option :value="0">0</option>
                                        <option :value="1">1</option>
                                        <option :value="2">2</option>
                                        <option :value="3">3</option>
                                        <option :value="4">4</option>
                                        <option :value="5">5</option>
                                        <option :value="6">6</option>
                                        <option :value="7">7</option>
                                        <option :value="8">8</option>
                                        <option :value="9">9</option>
                                        <option :value="10">10</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model="localData.products[i].quantity" @focus="handleInputFocus(localData.products[i], 'quantity')" @blur="handleInputBlur(localData.products[i], 'quantity', i)" @change="calculatePrices" class="form-control" min="0" type="number" step="any" inputmode="decimal" >
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Unit -->
                                <div class="col-4 col-xl-1" v-if="showProductUnit && (localData.products[i].product_id || localData.products[i].custom_product == true)">
                                    <label :for="'invoiceProductUnit' + i" class="form-label">{{$t('unity')}}</label>
                                    <input
                                        :id="'invoiceProductUnit' + i"
                                        v-model.trim="localData.products[i].unity"
                                        class="form-control"
                                        type="text"
                                        :placeholder="$t('unity')"
                                    >
                                </div>
                                <!-- VAT -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('vat')}} %</label>
                                    <select v-if="!localData.products[i].custom_vat_mode" class="form-select" :value="Number(localData.products[i].vat)" @change="onVatChange(i, $event)">
                                        <option :value="0">0%</option>
                                        <option :value="5">5%</option>
                                        <option :value="10">10%</option>
                                        <option :value="20">20%</option>
                                        <option :value="30">30%</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model.number="localData.products[i].vat" @focus="handleInputFocus(localData.products[i], 'vat')" @blur="handleInputBlur(localData.products[i], 'vat', i)" @change="calculatePrices" class="form-control" min="0" max="100" type="number" step="0.01" inputmode="decimal" pattern="[0-9]+(\.[0-9]{1,2})?" >
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToVatSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Subtotal -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('sub_total')}}: </label>
                                    <input v-model="localData.products[i].sub_total" @focus="handleInputFocus(localData.products[i], 'sub_total')" @blur="handleInputBlur(localData.products[i], 'sub_total', i)" class="form-control" min="0" max="100" type="number" step="0.01" inputmode="decimal"  >
                                </div>
                                <!-- Discount -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('discount')}} %</label>
                                    <select v-if="!localData.products[i].custom_discount_mode" class="form-select" :value="Number(localData.products[i].discount)" @change="onDiscountChange(i, $event)">
                                        <option :value="0">0%</option>
                                        <option :value="5">5%</option>
                                        <option :value="10">10%</option>
                                        <option :value="15">15%</option>
                                        <option :value="20">20%</option>
                                        <option :value="25">25%</option>
                                        <option :value="30">30%</option>
                                        <option :value="50">50%</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model="localData.products[i].discount" @focus="handleInputFocus(localData.products[i], 'discount')" @blur="handleInputBlur(localData.products[i], 'discount', i)" @change="calculatePrices" class="form-control"  min="0" max="100" type="number" step="0.01" inputmode="decimal">
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToDiscountSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Total -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('total')}}: </label>
                                    <input v-model.number="localData.products[i].total" @focus="handleInputFocus(localData.products[i], 'total')" @blur="handleInputBlur(localData.products[i], 'total', i)" class="form-control" @change="parseTTctoHt(i,localData.products[i].total)"  min="0" type="number" step="0.01" inputmode="decimal" >
                                </div>
                                <!-- Remove button -->
                                <div class="col-12 col-xl-1 d-none d-sm-block"  style="margin-top:25px">
                                    <button type="button" class="mb-3 btn line-item-delete-button" :aria-label="$t('delete')" :title="$t('delete')" @click="removeRow(i)"><AppIcon name="bi-trash" class="bi bi-trash" /></button>
                                </div>
                                <div v-if="salesHistoryFeatureEnabled && localData.client_id && localData.products[i].product_id" class="col-12 mt-2">
                                    <client-product-sales-history-card
                                        :client-id="localData.client_id"
                                        :client-name="localData.client?.name || ''"
                                        :product-id="localData.products[i].product_id"
                                        :exclude-invoice-id="localData.id || ''"
                                    />
                                </div>
                                <div class="col-12 d-block d-sm-none">
                                    <hr>
                                </div>
                            </div>  
                            </div>

                            <div class="row">
                                <div class="col-sm-9 btn-add-product">
                                    <button type="button" class="mb-3 btn btn-success btn-sm" @click="addNewRow"><PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" /> {{$t('product')}}</button>
                                </div>
                                <div class="col-sm-3 d-none d-sm-block" v-if="checkIfValidProduct()">
                                    <span>{{$t('sub_total')}} : <b>{{formatMoney(sub_total)}} </b> <br></span>
                                    <span>{{$t('vat')}} : <b>{{formatMoney(totalTvaPrice())}} </b></span> <br>
                                    <span v-if="total_discounted && total_discounted > 0">{{$t('discount')}} : <b>- {{formatMoney(total_discounted)}} </b> <br></span>
                                    <span v-if="total_discounted && total_discounted > 0">{{$t('net_ht_after_discount')}} : <b>{{formatMoney(net_ht_after_discount)}} </b> <br></span>
                                    <span>{{$t('total')}} : <b>{{ formatMoney(total) }} </b> <br></span>
                                </div>
                            </div>
                            
                        </div>

                        <hr>
                        <div class="row">
                            <div class="col-sm-3">
                                <label for="exampleFormControlInput1" class="form-label"><strong>{{$t('client')}}</strong></label>
                                <auto-complete  
                                        v-if="!modalIsLoading" 
                                        @emitAutoCompleteClient="emitAutoCompleteClient" 
                                        :defaultValue="localData?.client?.name"
                                        entity="clients"
                                        emitEvent="emitAutoCompleteClient"
                                ></auto-complete>
                                <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateClientModal">
                                    <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_client')}}
                                </a>
                                <small v-if="clientCurrencyEnabled" class="d-block mt-2 text-muted">
                                    {{$t('currency')}}: <strong>{{invoiceCurrency}}</strong>
                                </small>
                                <small v-if="usesForeignClientCurrency" class="d-block text-warning">
                                    {{$t('client_currency_no_conversion')}}
                                </small>
                            </div>
                        </div>

                        <hr v-if="checkIfValidProduct()">
                        <div class="table-responsive mb-4" v-if="localData.transactions && localData.transactions.length">
                            <label for="exampleFormControlInput1" class="form-label"><b>{{$t('payments_history')}}</b></label>
                            <table class="table mb-0 table-borderless table-striped small">
                                <thead>
                                    <tr class="text-secondary">
                                        <th class="pt-4 pb-3 px-6">{{$t('reference')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('amount')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('payment_method')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('status')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('created_at')}}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                <tr v-for="transaction in localData.transactions" :key="transaction.id">
                                    <td class="py-5 px-6">
                                        <router-link :to="`/payments/${transaction.id}`" target="_blank">
                                            <b>{{transaction.reference}}</b>
                                        </router-link>
                                    </td>
                                    <td class="py-5 px-6">{{formatMoney(transaction.amount)}} </td>
                                    <td class="py-5 px-6">{{transaction.payment_method}}</td>
                                    <td class="py-5 px-6">
                                        <span :class="{
                                            'badge bg-info': transaction.status === 'draft',
                                            'badge bg-success': transaction.status === 'paid',
                                            'badge bg-warning': transaction.status === 'partially_paid',
                                            'badge bg-danger': transaction.status === 'canceled' || transaction.status === 'overdue',
                                            'badge bg-secondary': transaction.status === 'pending'
                                        }">{{$t(transaction.status)}}</span>
                                    </td>
                                    <td class="py-5 px-6">{{formatDate(transaction.created_at)}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row" v-if="checkIfValidProduct() && action !== 'update'">
                            <label for="exampleFormControlInput1" class="form-label"><b>{{$t('payment')}}</b></label>

                            <div class="col-sm-2">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('payment_method')}}</label>
                                    <select v-if="!loadingPaymentMethods" v-model="localData.payment_method" class="form-select" aria-label="Default select example" :key="activePaymentMethods.length">
                                    <option v-for="method in activePaymentMethods" :key="method.id || method.name" :value="method.slug">
                                        {{ method.name }}
                                    </option>
                                </select>
                                <div v-else class="form-control">
                                    <small class="text-muted">{{ $t('loading') }}...</small>
                                </div>
                                <div v-if="paymentMethods.length === 0" class="mt-1">
                                    <a href="#" class="small text-decoration-none" @click.prevent="redirectToPaymentMethods">
                                        <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('add_payment_method')}}
                                    </a>
                                </div>
                            </div>
                            <div class="col-sm-2" v-if="localData.payment_method == 'cheque'">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('transaction_id')}}</label>
                                <input v-model="localData.pm_reference" type="string" class="form-control" id="amountPaidInput" >
                            </div>
                            <div class="col-sm-2">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('status')}}</label>
                                    <select v-model="localData.status" class="form-select" aria-label="Default select example">
                                    <option value="pending">{{$t('pending')}}</option>
                                    <option value="partially_paid">{{$t('partially_paid')}}</option>
                                    <option selected value="paid">{{$t('paid')}}</option>
                                    <option value="canceled">{{$t('canceled')}}</option>
                                    </select>
                            </div>
                            <div class="col-sm-2">
                                <label for="amountPaidInput" class="form-label">{{$t('amount_paid')}}</label>
                                <input v-model="amount_paid" type="number" class="form-control" id="amountPaidInput" placeholder="0,00" :min="0">
                            </div>

                            <div class="col-sm-2">
                                <label for="amountPaidInput" class="form-label" style="">{{$t('balance_due')}}</label>
                                <div class="p-1" style="font-size:18px;font-weight:bold">{{ formatMoney(total_amount_paid) }} </div>
                            </div>

                        </div>
                        <div v-if="checkIfValidProduct() && action === 'update'" class="mb-3">
                            <div class="row align-items-end g-3">
                                <div class="col-sm-3">
                                    <label class="form-label"><b>{{$t('balance_due')}}</b></label>
                                    <div class="p-1" style="font-size:18px;font-weight:bold">{{ formatMoney(total_amount_paid) }}</div>
                                </div>
                                <div class="col-sm-3" v-if="helper.checkAccess('create_payments') != -1">
                                    <button type="button" class="btn btn-success" @click="openNewPaymentForm" :disabled="total_amount_paid <= 0">
                                        <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                        {{$t('add_payment')}}
                                    </button>
                                </div>
                            </div>

                            <div v-if="showNewPaymentForm" class="card border mt-3">
                                <div class="card-body">
                                    <div class="row g-3 align-items-end">
                                        <div class="col-sm-2">
                                            <label for="newPaymentDate" class="form-label">{{$t('date')}}</label>
                                            <input id="newPaymentDate" v-model="newPayment.date" type="date" class="form-control">
                                        </div>
                                        <div class="col-sm-2">
                                            <label for="newPaymentMethod" class="form-label">{{$t('payment_method')}}</label>
                                            <select id="newPaymentMethod" v-if="!loadingPaymentMethods" v-model="newPayment.payment_method" class="form-select">
                                                <option v-for="method in activePaymentMethods" :key="method.id || method.name" :value="method.slug">
                                                    {{ method.name }}
                                                </option>
                                            </select>
                                            <div v-else class="form-control">
                                                <small class="text-muted">{{ $t('loading') }}...</small>
                                            </div>
                                        </div>
                                        <div class="col-sm-2" v-if="newPayment.payment_method === 'cheque'">
                                            <label for="newPaymentReference" class="form-label">{{$t('transaction_id')}}</label>
                                            <input id="newPaymentReference" v-model="newPayment.pm_reference" type="text" class="form-control">
                                        </div>
                                        <div class="col-sm-2">
                                            <label for="newPaymentAmount" class="form-label">{{$t('amount_paid')}}</label>
                                            <input id="newPaymentAmount" v-model.number="newPayment.amount_paid" type="number" class="form-control" min="0" :max="total_amount_paid" step="0.01" inputmode="decimal">
                                        </div>
                                        <div class="col-sm-3">
                                            <collapsible-notes-field v-model="newPayment.notes" id="new-payment-notes" rows="1" />
                                        </div>
                                        <div class="col-sm-auto d-flex gap-2">
                                            <button type="button" class="btn btn-outline-secondary" @click="cancelNewPayment" :disabled="addingPayment">
                                                {{$t('cancel')}}
                                            </button>
                                            <button type="button" class="btn btn-success" @click="addNewPayment" :disabled="addingPayment || !isNewPaymentValid">
                                                <span v-if="addingPayment" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                {{$t('add_payment')}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3 mt-2" v-if="business && business.payment_term">
                            <collapsible-notes-field
                                v-model="localData.payment_term"
                                id="paymentTermInput"
                                :label="$t('payment_term')"
                                :placeholder="$t('payment_term')"
                                rows="2"
                            />
                        </div>

                        <div class="mb-3">
                            <collapsible-notes-field v-model="localData.notes" id="invoice-notes" rows="3">
                                <div v-if="documentMode === 'invoice'" class="mt-2">
                                    <small v-if="loadingSuggestions" class="text-muted">
                                        <span class="spinner-border spinner-border-sm me-1"></span>{{ $t('loading') }}...
                                    </small>
                                    <div v-else-if="activeNoteSuggestions.length">
                                        <small class="d-block fw-bold text-muted mb-2">{{ $t('suggestions') }}:</small>
                                        <div class="d-flex flex-wrap gap-2" :aria-label="$t('suggestions')">
                                            <button
                                                v-for="suggestion in activeNoteSuggestions"
                                                :key="suggestion.id"
                                                type="button"
                                                class="badge rounded-pill border suggestion-badge"
                                                :class="isSuggestionApplied(suggestion) ? 'bg-success text-white border-success' : 'bg-light text-dark border-secondary'"
                                                :title="$t('click_to_add_suggestion')"
                                                @mousedown.prevent
                                                @click="appendSuggestion(suggestion)"
                                            >
                                                <AppIcon name="bi-check" v-if="isSuggestionApplied(suggestion)" class="bi bi-check me-1" />{{ suggestion.content }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </collapsible-notes-field>
                        </div>
                        

                    </div>
                    <div class="alert alert-warning" role="alert" v-if="msgError">
                        {{msgError}}
                    </div>
            </template>

            <template #footer>
                <!-- Mobile totals in footer -->
                <div class="mobile-totals d-block d-sm-none text-start me-auto" v-if="checkIfValidProduct()" style="font-size: 0.75rem;">
                    <div><small>{{$t('sub_total')}}:</small> <b>{{ formatMoney(sub_total) }}</b></div>
                    <div><small>{{$t('vat')}}:</small> <b>{{ formatMoney(totalTvaPrice()) }}</b></div>
                    <div v-if="total_discounted && total_discounted > 0"><small>{{$t('discount')}}:</small> <b>- {{ formatMoney(total_discounted) }}</b></div>
                    <div v-if="total_discounted && total_discounted > 0"><small>{{$t('net_ht_after_discount')}}:</small> <b>{{ formatMoney(net_ht_after_discount) }}</b></div>
                    <div><small>{{$t('total')}}:</small> <b>{{ formatMoney(total) }}</b></div>
                </div>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button v-if="action == 'update'" type="button" class="btn btn-success" @click="updateRow" :disabled="!checkIfValidProduct() || loading">
                    <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                    {{$t('edit')}}
                </button>
                <button v-if="['create','transfer'].includes(action)" type="button" class="btn btn-success" @click="saveRow" :disabled="!checkIfValidProduct() || loading"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
            </template>

        </CustomModal>

        <!-- client modal -->
        <add-client 
            v-if="createClientState"  
            :state="createClientState"  
            @createClient="createClient"/>
        <!-- client modal -->


        <!-- invoice modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-invoice-modal-22" 
            :isModalOpen="invoiceModalisOpen"  
            :data="data" 
            :type="documentMode === 'process' ? 'receipt' : documentMode">
        </invoice-template-modal>
        <!-- invoice modal -->

    </div>
   
    
    
</template>

<script>
import CustomModal from '../CustomModal.vue'
import helper from '../../helper'
import AutoComplete from '../autocomplete/AutoComplete'
import AddClient from '../AddClient.vue'
import InvoiceTemplateModal from '../invoiceLayout/InvoiceTemplateModal.vue'
import ProductRichTextEditor from '../common/ProductRichTextEditor.vue'
import ClientProductSalesHistoryCard from '../sales/ClientProductSalesHistoryCard.vue'
import draftAutosave from '../../mixins/draftAutosave'
import moment from 'moment'
import { getDefaultPaymentMethods } from '../../constants/paymentMethods'
export default {
  name: 'AddEditInvoiceModal',
  mixins: [draftAutosave],
  props : {
        action: {
            type: String,
            required: true
        },
        data: {
            default: false
        },
        isModalOpen: {
            type: Boolean,
            default: false
        },
        modalId : {
            type : String,
            default : 'exampleModal'
        },
        from : {
            type : String
        },
        documentMode: {
            type: String,
            default: 'invoice'
        },
        documentTitle: {
            type: String,
            default: ''
        }
    },
  components : {
    CustomModal,
    AutoComplete,
    AddClient,
    InvoiceTemplateModal,
    ProductRichTextEditor,
    ClientProductSalesHistoryCard
  },
  data(){
    const parsedData = JSON.parse(JSON.stringify(this.data))

    // A transferred quote/order/delivery carries its own document status.
    // Invoice status represents payment state, so conversions must start pending.
    if (this.action === 'transfer') {
      parsedData.status = 'pending'
    }

    // Ensure essential fields exist for Vue reactivity
    if (!parsedData.payment_method) {
      parsedData.payment_method = ''
    }
    if (!parsedData.payment_term) {
      parsedData.payment_term = ''
    }
    if (!parsedData.client) {
      parsedData.client = {}
    }
    if (typeof parsedData.is_recurring !== 'boolean') {
      parsedData.is_recurring = false
    }
    if (!['day', 'week', 'month', 'quarter', 'half_year', 'year'].includes(parsedData.recurrence_interval)) {
      parsedData.recurrence_interval = 'month'
    }
    
    let amount_paid = parsedData.amount_paid || 0
    if (parsedData.transactions && parsedData.transactions.length) {
        amount_paid = parsedData.transactions
            .filter(t => t.status === 'paid')
            .map(t => t.amount)
            .reduce((a, c) => parseFloat(a) + parseFloat(c), 0);
        parsedData.amount_paid = amount_paid;
    }

    return {
        loading : false,
        invoiceModalStatus : false,
        invoiceModalisOpen :false,
        createClientState : false,
        hideClient : false,
        localData: parsedData,
        // Keep the File outside localData because draft autosave serializes localData.
        scannedFile: this.data && this.data.scannedFile ? this.data.scannedFile : null,
        amount_paid : amount_paid,
        modalIsLoading : false,
        msgError : null,
        paymentMethods: [],
        loadingPaymentMethods: false,
        showNewPaymentForm: false,
        addingPayment: false,
        suggestions: [],
        loadingSuggestions: false,
        newPayment: {
            date: moment().format('YYYY-MM-DD'),
            payment_method: '',
            pm_reference: '',
            amount_paid: null,
            notes: ''
        }
    }
  },
 
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    showProductUnit(){ return this.documentMode === 'invoice' && this.business?.metadata?.show_product_unit === true },
    recurringInvoiceFeatureEnabled(){
        return this.documentMode === 'invoice'
            && (this.business?.metadata?.recurring_invoices_enabled === true || this.localData.is_recurring === true)
    },
    salesHistoryFeatureEnabled(){
        return this.documentMode === 'invoice' && this.business?.metadata?.show_client_product_sales_history === true
    },
    canCreateCatalogProducts(){
        return this.documentMode === 'invoice'
            && this.isProductModuleEnabled
            && this.business?.metadata?.allow_custom_product_catalog_creation === true
            && ![-1, -2].includes(helper.checkAccess('create_inventories'))
    },
    resolvedDocumentTitle(){ return this.documentTitle || this.$t('invoice') },
    apiResource(){ return this.documentMode === 'process' ? 'processes' : 'invoices' },
    documentIdField(){ return this.documentMode === 'process' ? 'process_id' : 'invoice_id' },
    clientCurrencyEnabled(){
        return !!this.business?.metadata?.use_client_currency_for_invoices
    },
    invoiceCurrency(){
        return this.localData.currency || this.business?.currency || '$'
    },
    usesForeignClientCurrency(){
        return this.clientCurrencyEnabled &&
            !!this.localData.client?.currency &&
            this.invoiceCurrency !== this.business?.currency
    },
    isProductModuleEnabled(){ return helper.checkModuleIsEnabled('products') },
    total(){ return this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return parseFloat(a) + parseFloat(c) }) : 0},
    sub_total(){ return this.localData.products.length ? this.localData.products.map(o => o.sub_total).reduce((a, c) => { return parseFloat(a) + parseFloat(c) }) : 0},
    total_discounted(){ return this.localData.products.length ? this.localData.products.map(o => o.total_discount).reduce((a, c) => { return parseFloat(a) + parseFloat(c) }) : 0},
    net_ht_after_discount(){ return (parseFloat(this.sub_total) || 0) - (parseFloat(this.total_discounted) || 0) },
    total_amount_paid(){
        if(this.action === 'update') return Math.max(0, this.total - (parseFloat(this.amount_paid) || 0))
        if(!this.localData.transactions || !this.localData.transactions.length) return (this.total - (parseFloat(this.amount_paid) || 0))
        return (this.total - (this.localData.transactions.map(transaction => transaction.amount).reduce((a,c) => { return parseFloat(a) + parseFloat(c) }) + parseFloat(this.amount_paid || 0)))
    },
    isNewPaymentValid(){
        return Number(this.newPayment.amount_paid) > 0 &&
            Number(this.newPayment.amount_paid) <= this.total_amount_paid &&
            !!this.newPayment.date &&
            !!this.newPayment.payment_method
    },
    activePaymentMethods(){
        // Filter only active payment methods or return the standard defaults
        const activeMethods = this.paymentMethods.filter(method => method.is_active)
        
        // Keep payment options available if the API cannot provide them
        if (activeMethods.length === 0) {
            return getDefaultPaymentMethods()
        }
        
        return activeMethods
    },
    activeNoteSuggestions(){
        return this.suggestions.filter(suggestion => suggestion.enabled && suggestion.applies_to === 'invoice_notes')
    },
    helper(){ return helper},
  },
  methods : {
    draftAutosaveResource(){ return this.apiResource },
    async fetchInvoiceSuggestions(){
        if (this.documentMode !== 'invoice') return
        try {
            this.loadingSuggestions = true
            const response = await helper.customGet(`${process.env.VUE_APP_API}/suggestions?applies_to=invoice_notes&enabled=true`)
            this.suggestions = response.data.data || []
        } catch (error) {
            this.suggestions = []
        } finally {
            this.loadingSuggestions = false
        }
    },
    isSuggestionApplied(suggestion){
        const notes = String(this.localData.notes || '').trim()
        return notes.includes(suggestion.content.trim())
    },
    appendSuggestion(suggestion){
        if (this.isSuggestionApplied(suggestion)) return
        const notes = String(this.localData.notes || '').replace(/\s+$/, '')
        this.$set(this.localData, 'notes', notes ? `${notes}\n${suggestion.content}` : suggestion.content)
    },
    async openNewPaymentForm(){
        this.showNewPaymentForm = true
        this.newPayment.date = moment().format('YYYY-MM-DD')
        this.newPayment.amount_paid = null
        this.newPayment.pm_reference = ''
        this.newPayment.notes = ''

        if (!this.paymentMethods.length) {
            await this.fetchPaymentMethods(true)
        } else if (!this.newPayment.payment_method) {
            const defaultMethod = this.paymentMethods.find(method => method.is_default && method.is_active)
                || this.paymentMethods.find(method => method.is_active)
            this.newPayment.payment_method = defaultMethod ? defaultMethod.slug : 'cash'
        }
    },
    cancelNewPayment(){
        this.showNewPaymentForm = false
        this.newPayment.amount_paid = null
        this.newPayment.pm_reference = ''
        this.newPayment.notes = ''
    },
    async addNewPayment(){
        if (!this.isNewPaymentValid || !this.localData.id) return

        try {
            this.addingPayment = true
            await helper.customPost(`${process.env.VUE_APP_API}/transactions`, {
                [this.documentIdField]: this.localData.id,
                client_id: this.localData.client_id || this.localData.client?.id || null,
                payment_method: this.newPayment.payment_method,
                pm_reference: this.newPayment.pm_reference || null,
                amount_paid: Number(this.newPayment.amount_paid),
                status: 'paid',
                date: this.newPayment.date,
                notes: this.newPayment.notes || '',
                is_incoming: true,
                paymentable_type: this.documentMode,
                paymentable_id: this.localData.id
            }, {showToast: true})

            const response = await helper.customGet(`${process.env.VUE_APP_API}/${this.apiResource}/${this.localData.id}`)
            const refreshedInvoice = response.data
            this.$set(this.localData, 'transactions', refreshedInvoice.transactions || [])
            this.$set(this.localData, 'amount_paid', parseFloat(refreshedInvoice.amount_paid) || 0)
            this.amount_paid = parseFloat(refreshedInvoice.amount_paid) || 0
            if (this.amount_paid >= this.total) {
                this.localData.status = 'paid'
            } else if (this.amount_paid > 0) {
                this.localData.status = 'partially_paid'
            } else {
                this.localData.status = 'pending'
            }
            this.cancelNewPayment()
            this.$emit('refresh', true)
        } catch (error) {
            this.msgError = error?.response?.data?.message || error.message || this.$t('an_error_occurred')
        } finally {
            this.addingPayment = false
        }
    },
    async fetchPaymentMethods(forceDefault = false) {
      this.loadingPaymentMethods = true
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/payment-methods?per_page=100`)
        this.paymentMethods = response.data.data || []
        
        // If no payment methods exist, use the standard defaults
        if (this.paymentMethods.length === 0) {
          this.paymentMethods = getDefaultPaymentMethods()
        }
        
        // Wait for loading to complete before setting default
        this.loadingPaymentMethods = false
        
        // Set the default payment method if not already defined (check for empty string too) or if forced
        if (forceDefault || !this.localData.payment_method || this.localData.payment_method === '') {
          await this.$nextTick()
          
          const defaultMethod = this.paymentMethods.find(method => method.is_default === true)
          let defaultSlug = 'cash'
          
          if (defaultMethod) {
            defaultSlug = defaultMethod.slug
          } else {
            // If no default is set, use the first active payment method or 'cash'
            const firstActiveMethod = this.paymentMethods.find(method => method.is_active === true)
            defaultSlug = firstActiveMethod ? firstActiveMethod.slug : 'cash'
          }
          
          this.localData.payment_method = defaultSlug
          this.newPayment.payment_method = defaultSlug
          await this.$nextTick()
        }
      } catch (error) {
        alert(error)
        // On error, keep the standard payment options available
        this.paymentMethods = getDefaultPaymentMethods()
        this.loadingPaymentMethods = false
        if (forceDefault || !this.localData.payment_method || this.localData.payment_method === '') {
          await this.$nextTick()
          this.localData.payment_method = 'cash'
          this.newPayment.payment_method = 'cash'
        }
      }
    },
    async saveRow(){
        try{
            this.loading = true
            this.msgError = ''

            if (this.business?.metadata?.strict_stock_mode) {
                 const outOfStockProducts = this.localData.products.filter(p => p.product_id && Number(p.quantity) > 0 && (p.maxQty === undefined || p.maxQty <= 0) && !p.custom_product);
                 if (outOfStockProducts.length > 0) {
                     this.msgError = this.$t('cannot_create_invoice_out_of_stock');
                     this.loading = false;
                     window.vueOpener.open({
                        message: this.msgError,
                        type: 'warning',
                        position: 'bottom'
                    });
                    return;
                 }
            }

            this.sanitizeCustomProductLabels()

            if(!this.localData.client_id && this.localData.client && this.localData.client.id ){
                this.localData.client_id = this.localData.client.id
            }

            this.localData.amount_paid = this.amount_paid
            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError) {
                this.loading = false
                window.vueOpener.open({
                    message: this.msgError,
                    type: 'warning',
                    position: 'bottom'
                });
                return
            }

            if(this.documentMode === 'invoice'){
                await helper.createCatalogProductsFromCustomRows(this.localData.products)
            }

            //format products
            this.localData.products = helper.formatProducts(this.localData.products, true)

            // Update the existing draft instead of creating a new one
            await this.pauseDraftAutosave()
            const payload = {...this.localData}
            delete payload.scannedFile
            const response = await helper.customPatch(`${process.env.VUE_APP_API}/${this.apiResource}/${this.localData.id}`, payload, {showToast:true})

            if(this.documentMode === 'invoice' && this.scannedFile){
                await this.uploadScannedInvoice(this.localData.id)
            }
            
            //confirm quote if exists
            if(this.documentMode === 'invoice' && this?.localData?.quote_id){
                await helper.customPatch(`${process.env.VUE_APP_API}/quotes/${this.localData.quote_id}`,{ status : 'confirmed', invoice_id : this.localData.id },{showToast:false})
            }
            // Confirm multiple quotes if bulk transfer
            if(this.documentMode === 'invoice' && this?.localData?.quote_ids && Array.isArray(this.localData.quote_ids)){
                 await Promise.all(this.localData.quote_ids.map(id => 
                    helper.customPatch(`${process.env.VUE_APP_API}/quotes/${id}`,{ status : 'confirmed', invoice_id : this.localData.id },{showToast:false})
                 ));
            }
            
            //confirm delivery if exists
            if(this.documentMode === 'invoice' && this?.localData?.delivery_id){
                await helper.customPatch(`${process.env.VUE_APP_API}/deliveries/${this.localData.delivery_id}`,{ status : 'delivered' },{showToast:false})
            }
            // Confirm multiple deliveries if bulk transfer
            if(this.documentMode === 'invoice' && this?.localData?.delivery_ids && Array.isArray(this.localData.delivery_ids)){
                 await Promise.all(this.localData.delivery_ids.map(id => 
                    helper.customPatch(`${process.env.VUE_APP_API}/deliveries/${id}`,{ status : 'delivered' },{showToast:false})
                 ));
            }
            
            //confirm order if exists
            if(this.documentMode === 'invoice' && this?.localData?.order_id){
                await helper.customPatch(`${process.env.VUE_APP_API}/orders/${this.localData.order_id}`,{ status : 'confirmed' },{showToast:false})
            }
            // Confirm multiple orders if bulk transfer
            if(this.documentMode === 'invoice' && this?.localData?.order_ids && Array.isArray(this.localData.order_ids)){
                 await Promise.all(this.localData.order_ids.map(id => 
                    helper.customPatch(`${process.env.VUE_APP_API}/orders/${id}`,{ status : 'confirmed' },{showToast:false})
                 ));
            }

            this.clearForm()
            this.loading = false
            this.modalClosed()
            if (this.documentMode === 'invoice') this.$router.push({path : `/invoices/${response.data.id}`})
            else this.$emit('refresh', true)

        }catch(error){
            this.resumeDraftAutosave()
            this.loading = false
        }
    },
    async updateRow(){
        try{
            this.loading = true
            this.msgError = ''

            if (this.business?.metadata?.strict_stock_mode) {
                 const outOfStockProducts = this.localData.products.filter(p => p.product_id && Number(p.quantity) > 0 && (p.maxQty === undefined || p.maxQty <= 0) && !p.custom_product);
                 if (outOfStockProducts.length > 0) {
                     this.msgError = this.$t('cannot_create_invoice_out_of_stock');
                     this.loading = false;
                     window.vueOpener.open({
                        message: this.msgError,
                        type: 'warning',
                        position: 'bottom'
                    });
                    return;
                 }
            }

            this.sanitizeCustomProductLabels()

            if(!this.localData.client_id && this.localData.client && this.localData.client.id ){
                this.localData.client_id = this.localData.client.id
            }
            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError) {
                this.loading = false
                window.vueOpener.open({
                    message: this.msgError,
                    type: 'warning',
                    position: 'bottom'
                });
                return
            }

            if(this.documentMode === 'invoice'){
                await helper.createCatalogProductsFromCustomRows(this.localData.products)
            }

            //format products
            this.localData.products = helper.formatProducts(this.localData.products, true)

            const payload = {...this.localData}
            delete payload.scannedFile
            // Payments are managed as separate transactions in edit mode. Omitting these
            // fields prevents an invoice edit from canceling and recreating payment history.
            delete payload.amount_paid
            delete payload.payment_method
            delete payload.pm_reference

            await this.pauseDraftAutosave()
            await helper.customPatch(`${process.env.VUE_APP_API}/${this.apiResource}/${this.localData.id}`, payload)
            this.loading = false
            this.clearForm()
            this.modalClosed()
            this.$emit('refresh',true)

        }catch(error){
            this.resumeDraftAutosave()
            this.loading = false
        }
    },
    clearForm(){
        this.localData = {
            id : null,
            reference : '',
            client_id : null,
            client : {},
            currency: this.business?.currency || '$',
            payment_term: '',
            client_po_number: '',
            client_dn_number: '',
            date : '',
            total : 0,
            products : []
        }
    },
    addNewRow(){
        this.localData.products.push({
            id : null,
            label : '',
            product_label : '',
            quantity : 0,
            unity : null,
            price : 0,
            discount : 0,
            vat :  this.business.vat,
            total : 0,
            sub_total : 0,
            custom_product : !this.isProductModuleEnabled,
            create_catalog_product : false,
            custom_quantity_mode : false,
            custom_discount_mode : false,
            custom_vat_mode : false,
            variants: [],
            variant_id: null
        })
        this.calculatePrices();
    },
    removeRow(i){
       this.localData.products.splice(i, 1);
       this.calculatePrices();
    },
    onQuantityChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_quantity_mode = true;
        } else {
            this.localData.products[index].custom_quantity_mode = false;
            this.localData.products[index].quantity = Number(val);
            this.calculatePrices();
        }
    },
    switchToSelectMode(index) {
        this.localData.products[index].custom_quantity_mode = false;
        this.localData.products[index].quantity = 0;
        this.calculatePrices();
    },
    onDiscountChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_discount_mode = true;
        } else {
            this.localData.products[index].custom_discount_mode = false;
            this.localData.products[index].discount = Number(val);
            this.calculatePrices();
        }
    },
    switchToDiscountSelectMode(index) {
        this.localData.products[index].custom_discount_mode = false;
        this.localData.products[index].discount = 0;
        this.calculatePrices();
    },
    onVatChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_vat_mode = true;
        } else {
            this.localData.products[index].custom_vat_mode = false;
            this.localData.products[index].vat = Number(val);
            this.calculatePrices();
        }
    },
    switchToVatSelectMode(index) {
        this.localData.products[index].custom_vat_mode = false;
        this.localData.products[index].vat = 0;
        this.calculatePrices();
    },
    handleInputFocus(row, field){
        if(row[field] == 0){
            row[field] = ''
        }
    },
    handleInputBlur(row, field, index){
        if(row[field] === '' || row[field] === null || row[field] === undefined){
            row[field] = 0
            if(field === 'total'){
                this.parseTTctoHt(index, 0)
            }else if(['price','quantity','vat','discount'].includes(field)){
                this.calculatePrices()
            }
        }
    },
    calculatePrices() {
      this.msgError = null;
      this.$forceUpdate();

      for (let i = 0; i < this.localData.products.length; i++) {
        let product = this.localData.products[i];

        const qty = Number(product.quantity) || 0;
        const price = Number(product.price) || 0;
        const discountRate = Number(product.discount) || 0;
        const vatRate = Number(product.vat) || 0;

        // Derive unit HT depending on configuration
        let unitPriceHT = 0;
        const productPriceIncludesTax = (product.price_includes_tax === true) || (product.product?.price_includes_tax === true) || (this.business?.price_includes_tax === true);
        if (productPriceIncludesTax) {
          unitPriceHT = vatRate > 0 ? price / (1 + vatRate / 100) : price;
        } else {
          unitPriceHT = price;
        }

        // Subtotal (HT) before discount
        const subTotalHT = unitPriceHT * qty;
        product.sub_total = Math.round(subTotalHT * 100) / 100;

        // Discount (applied on HT)
        const discountAmount = product.sub_total * (discountRate / 100);
        product.total_discount = Math.round(discountAmount * 100) / 100;

        // VAT is applied on the discounted HT base
        const vatBase = product.sub_total - product.total_discount;
        const tvaAmount = vatRate > 0 ? vatBase * (vatRate / 100) : 0;

        // Final total TTC
        product.total = Math.round((vatBase + tvaAmount) * 100) / 100;
      }

      // Global total
      this.localData.total = this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => a + c, 0): 0;
    },
    totalTvaPrice() {
      let total = 0;
      if (this.localData && this.localData.products.length) {
        for (let i = 0; i < this.localData.products.length; i++) {
          const p = this.localData.products[i];
          const vatRate = Number(p.vat) || 0;
          const subHT = Number(p.sub_total) || 0;
          const discount = Number(p.total_discount) || 0;
          const vatBase = Math.max(subHT - discount, 0);
          total += (vatRate / 100) * vatBase;
        }
      }
      return Math.round(total * 100) / 100;
    }, 
    parseTTctoHt(index, price) {
      if(price === '') return
      const prd = this.localData.products[index];
      const qty = Number(prd?.quantity) || 0;
      const vatRate = Number(prd?.vat) || 0;
      const discountRate = Number(prd?.discount) || 0;
      const totalTTC = Number(price) || 0;
      if (totalTTC > 0 && qty > 0) {
        const taxFactor = 1 + vatRate / 100;
        const discountFactor = 1 - discountRate / 100;

        // A positive TTC total cannot be represented by a fully discounted line.
        if (discountFactor <= 0) return;

        // The entered total is after discount and VAT. Reverse both so that a
        // later recalculation (and the printed HT/VAT summary) preserves it.
        const lineTTCBeforeDiscount = totalTTC / discountFactor;
        const unitTTCBeforeDiscount = lineTTCBeforeDiscount / qty;
        const productPriceIncludesTax = (prd.price_includes_tax === true) || (prd.product?.price_includes_tax === true) || (this.business?.price_includes_tax === true);
        if (productPriceIncludesTax) {
          // Price field is TTC when business or product prices include tax
          prd.price = Math.round(unitTTCBeforeDiscount * 1e10) / 1e10;
        } else {
          // Price field is HT when business and product prices exclude tax
          const unitHT = unitTTCBeforeDiscount / taxFactor;
          prd.price = Math.round(unitHT * 1e10) / 1e10;
        }

        const lineHTBeforeDiscount = lineTTCBeforeDiscount / taxFactor;
        prd.sub_total = Math.round(lineHTBeforeDiscount * 100) / 100;
        prd.total_discount = Math.round((prd.sub_total * discountRate / 100) * 100) / 100;
        prd.total = Math.round(totalTTC * 100) / 100;
        this.localData.total = this.localData.products.reduce((sum, product) => sum + (Number(product.total) || 0), 0);
      }
    },
    calculateDiscount(){
        for(let i = 0 ; i < this.localData.products.length ; i++){
            if(this.localData.products[i].discount){
                this.$set(this.localData.products[i], 'total_discount', (parseFloat(this.localData.products[i].sub_total) * (parseFloat(this.localData.products[i].discount) / 100)));
            }
        }
    },
    emitAutoComplete(data){
        if (data && data.result) {
        if(!this.localData.products.find(product => product.product_id == data.result.product.id)){
             this.localData.products[data.index] = {
                ...{
                inventory_id : data.result.id,
                product_id : data.result.product.id,
                label : data.result.product.label,
                product_label : data.result.product.label,
                quantity : 0,
                discount : 0,
                maxQty : data.result.quantity,
                price : data.result.price,
                price_includes_tax : (data.result.product?.price_includes_tax === true) || (data.result.price_includes_tax === true),
                unity : data.result.unity,
                purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
                vat :  data.result.vat ? data.result.vat : this.business.vat,
                total : data.result.total ? data.result.total : 0,
                sub_total : data.result.sub_total ? data.result.sub_total : 0,
                custom_product : false,
                create_catalog_product : false,
                custom_quantity_mode : false,
                custom_discount_mode : false,
                custom_vat_mode : false,
                variants: data.result.product.variants || [],
                variant_id: data.result.variant_id || null
            }}
            this.localData.products = [...this.localData.products]
        }
        }
    },

    emitAutoCompleteClient(data){
        if (data && data.result) {
            this.modalIsLoading = true
            this.localData.client_id = data.result.id
            this.localData.client = data.result
            this.syncInvoiceCurrency()
            this.resolvePaymentTerm();
            setTimeout(() => {
                this.modalIsLoading = false
            }, 100)
        } else {
            this.localData.client_id = null
            this.localData.client = {}
            this.syncInvoiceCurrency()
        }
    },
    openCreateClientModal(){
        this.createClientState = !this.createClientState
    },
    createClient(data){
        if(data.client){
            this.localData.client_id = data.client.id
            this.localData.client = data.client
            this.syncInvoiceCurrency()
            this.resolvePaymentTerm();
        }
        if(data && data.state != undefined){
            this.createClientState = data.state
            this.modalIsLoading = true
            setTimeout(() => { this.modalIsLoading = false })
        }
    },
    emitAutoCompleteOrder(data){
        if (data && data.result) {
            this.modalIsLoading = true
            this.productSuggestion = false
            this.localData.products = data.result.products
            this.localData.client_id = data.result.client_id
            this.localData.client = data.result.client
            this.syncInvoiceCurrency()
            this.localData.order_id = data.result.id
            this.localData.order = data.result
            this.localData.reference = data.result.reference
            this.localData.payment_method = data.result.payment_method
            this.resolvePaymentTerm();
            this.modalIsLoading = false
        }
    },
    checkIfValidProduct(){
        return this.localData.products.length > 0 && this.localData.products.every(product => (
            product.product_id != null
            || (product.custom_product === true && helper.richTextToPlainText(product.product_label).trim().length > 0)
        ))
    },
    isProductFilled(product){
        if(product.custom_product){
             return helper.richTextToPlainText(product.product_label).trim().length > 0
        } 
        return product.product_id ? true : false
    },
    sanitizeCustomProductLabels(){
        this.localData.products.forEach(product => {
            if (product.custom_product) {
                product.product_label = helper.sanitizeRichText(product.product_label)
            }
        })
    },
    async modalClosed(){
        if(this.draftAutosaveClosing) return
        this.draftAutosaveClosing = true
        await this.pauseDraftAutosave(this.draftAutosaveEligible)
        if(document.getElementById('close-modal-btn')){
            document.getElementById('close-modal-btn').click()
        }
        this.clearForm()
        this.$emit('modalClosed', true)
    },
    //helper functions
    formatDate(date,locale) { return helper.formatDate(date,locale) },
    formatMoney(number) { return helper.formatMoney(number, this.invoiceCurrency);},
    formatReference(number,id) { return helper.formatReference(number,id);},
    syncInvoiceCurrency() {
        const currency = this.clientCurrencyEnabled
            ? (this.localData.client?.currency || this.business?.currency)
            : this.business?.currency
        this.$set(this.localData, 'currency', currency || '$')
    },
    resolvePaymentTerm() {
        if (!this.business || !this.business.payment_term) return;
        let term = this.business.payment_term;
        const clientName = this.localData.client?.name || '';
        const clientAddress = this.localData.client?.address || '';
        const currentDate = helper.formatDate(new Date());
        term = term.replace(/\{client\.name\}/g, clientName);
        term = term.replace(/\{client\.address\}/g, clientAddress);
        term = term.replace(/\{client\}/g, clientName);
        // Handle {date+Nunit} patterns, e.g. {date+1month}, {date+30days}, {date+2weeks}, {date+1year}
        term = term.replace(/\{date\+(\d+)(day|days|week|weeks|month|months|year|years)\}/gi, (match, num, unit) => {
            const normalized = unit.toLowerCase().replace(/s$/, '');
            return helper.formatDate(moment().add(parseInt(num), normalized + 's').toDate());
        });
        term = term.replace(/\{date\}/g, currentDate);
        this.$set(this.localData, 'payment_term', term);
    },
    onVariantChange(index){
        const product = this.localData.products[index];
        const variant = product.variants.find(v => v.id === product.variant_id);
        if(variant){
            product.price = variant.price;
            if(variant.inventory){
                 product.inventory_id = variant.inventory.id;
                 product.maxQty = variant.inventory.quantity;
            }
            this.calculatePrices();
        }
    },
    async redirectToPaymentMethods() {
        await this.modalClosed();
        this.$router.push({ path: '/settings', query: { openPaymentMethods: 'true' } });
    },
    async uploadScannedInvoice(invoiceId){
        await helper.customUploadFile(
            this.scannedFile,
            `businesses/${this.business.id}/attachments/${helper.generateRandString(20)}`,
            {
                entity_type: 'invoice',
                entity_id: invoiceId,
                is_private: 0,
                notes: 'Scanned Invoice'
            }
        )
    }
  },
  async created(){
    let createdServerDraft = false
    if(this.localData.date) {
        this.localData.date = moment(this.localData.date).format('YYYY-MM-DD')
    }else{
        this.localData.date = moment().format('YYYY-MM-DD')
    }

    if(this.localData.due_date) {
        this.localData.due_date = moment(this.localData.due_date).format('YYYY-MM-DD')
    }
    
    this.calculatePrices()

    if(this.localData.products.length){
        for(let i = 0 ; i < this.localData.products.length ; i++){
            if(!this.localData.products[i].discount){
                this.localData.products[i].discount = 0
            }
            // If product module is not enabled, force custom_product mode
            if (!this.isProductModuleEnabled) {
                this.$set(this.localData.products[i], 'custom_product', true);
            }
            this.$set(this.localData.products[i], 'create_catalog_product', false);
            const q = Number(this.localData.products[i].quantity);
            this.$set(this.localData.products[i], 'custom_quantity_mode', ![0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(q));
            const d = Number(this.localData.products[i].discount);
            this.$set(this.localData.products[i], 'custom_discount_mode', ![0, 5, 10, 15, 20, 25, 30, 50].includes(d));
            const v = Number(this.localData.products[i].vat);
            this.$set(this.localData.products[i], 'custom_vat_mode', ![0, 5, 10, 20, 30].includes(v));
        }
    }

    //add default status
    if(!this.localData.status){
        this.localData.status = 'draft'
    }

    if(this.localData.order){
        this.localData.order_id = this.localData.order.id
    }

    if(this.from && this.from == 'orders'){
        this.localData.order = {
            id : this.localData.id,
            reference : this.localData.reference
        }
        this.localData.order_id = this.localData.id
    }

    // When creating, immediately create a draft on the server and keep its id/reference
    // We only create a new draft if no ID is already provided (normal creation)
    // or if we're transferring from another document (which requires a new invoice ID)
    if((this.action === 'create' && !this.localData.id) || this.action === 'transfer'){
        const { data } = await helper.customPost(`${process.env.VUE_APP_API}/${this.apiResource}/draft`,{})
        createdServerDraft = true
        
        this.localData.id = data.id
        this.localData.currency = data.currency || this.business?.currency
        
        // If not scanned (normal create), use the draft's generated reference/date
        // If scanned, keep the extracted reference/date
        if(!this.localData.isScanned) {
            this.localData.reference = data.reference
            if(data.date){
                this.localData.date = moment(data.date).format('YYYY-MM-DD')
            }
        }
    }

    this.syncInvoiceCurrency()
    
    // Fetch payment methods and set default (force=true to override draft default)
    await Promise.all([
        this.fetchPaymentMethods(true),
        this.fetchInvoiceSuggestions()
    ])

    if (!this.localData.payment_term && this.business && this.business.payment_term) {
        this.resolvePaymentTerm();
    }

    this.startDraftAutosave(
        createdServerDraft,
        ['create', 'transfer'].includes(this.action) || this.data?.status === 'draft'
    )

  },
  watch : {
        'amount_paid'(newAmount) {
            if (newAmount >= this.localData.total) {
                this.localData.status = 'paid';
            } else if (newAmount != 0 && newAmount < this.localData.total){
                this.localData.status = 'partially_paid';
            } else if (newAmount == 0) {
                this.localData.status = 'pending';
            } 
        },
        'localData.status'(newVal){
            if(newVal == 'paid'){
                this.amount_paid = this.localData.total
            }
        },
        total(newTotal) {
            if (this.localData.status === 'paid') {
                this.amount_paid = newTotal;
            } else if (this.localData.status === 'partially_paid') {
                if (this.amount_paid > newTotal) {
                    this.amount_paid = newTotal;
                }
            }
        }
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
    .suggestion-badge {
        max-width: 100%;
        padding: 0.5rem 0.75rem;
        white-space: normal;
        text-align: start;
        cursor: pointer;
    }
    /* Mobile-only: cap products list height and enable inner scrolling */
    @media (max-width: 575.98px) {
        .products-scroll {
            max-height: 60vh;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            box-shadow: 1px 1px 2px 2px #ddd;
            margin-bottom: 10px;
            padding-top: 10px;
            background: #fdfdfd;
            border: 1px solid #ddd;
            height: 300px
        }
        .products-scroll .row {
            margin-left: 0;
            margin-right: 0;
        }
    }
</style>
